<template>
  <div></div>
</template>
<!--<template>
  <div class="page-container">
    <LoadingOverlay :visible="loading || searchLoading" :message="searchLoading ? 'جارٍ البحث...' : loadingMessage" title="جاري التحميل" />
    <div class="page-header">
      <div class="left-actions">
        <UserBadge />
      </div>
      <div class="left-actions">
        <button @click="goBack" class="btn-back">← العودة</button>
      </div>
    </div>

    <div class="content">     
      <SearchItem :searchLoading="searchLoading" :selectedItems="selectedItems" :itemsCount="itemsCount" :dropdownItems="dropdownItems" :items="items" :itemsSearch="itemsSearch" :SearchItem="SearchItem" @updateSearchLoading="searchLoading = $event" @updateSelectedItem="selectedItems = $event" />
      <div class="page-header right-actions ">
      <LookUp label="نوع الطلب" :arryinfo="kinds2" :value="kind" :disa="false" @UpdateVmodel="kind=$event"/>          
      <button 
          v-if="selectedItems.length>0"
          class="btn-toggle-notes" 
          @click="showNotes = !showNotes"
          :title="showNotes ? 'إخفاء الملاحظات' : 'إظهار الملاحظات'"
        >
          {{ showNotes ? '📝' : '📄' }}
      </button>
      <LookUp v-if="kind == 5" label="من المستودع" :arryinfo="warehouses" :value="transferFrom" :disa="false" @UpdateVmodel="transferFrom=$event"/>
      <LookUp v-else label="المستودع" :arryinfo="warehouses" :value="transferFrom" :disa="false" @UpdateVmodel="transferFrom=$event"/>          
      <LookUp v-if="kind == 5" label="إلى المستودع" :arryinfo="warehouses" :value="transferTo" :disa="false" @UpdateVmodel="transferTo=$event"/>  
      <LookUp v-else label="الحساب" :arryinfo="accounts" :value="account" :disa="false"  @UpdatePrice="async($event)=>{load_message('تحديث الأسعار');console.log('$event1:'+$event); 
       itemsSearch = generateItems($event) ;}" @UpdateVmodel="($event)=>{account=$event;console.log('$event2:'+$event); }"/>           
      </div>     
      <div v-show="showNotes && selectedItems.length>0" class="notes-field">
        <textarea v-model="transferNotes" placeholder="أضف ملاحظات عن الطلب..." class="notes-input" rows="3" maxlength="50"></textarea>
        <div class="notes-counter">{{ transferNotes.length }} / 50</div>
      </div>    {{ selectedItems }}
      <InsertItem :items="selectedItems" @updateSelectedItem="selectedItems = $event" @send="sendTransferRequest" @clearItems="clearSelected"/>      
      <OrderList :requests="requests"/>      
    </div>
    <ContextMenu @select="handleMenuSelect" />
    <StatisticsModal 
      :requests="requests"
      :isOpen="showStatistics"
      @close="showStatistics = false"
    />
    <PreviousRequestsModal
      :requests="requests_previos"
      :isOpen="showPreviousRequestsModal"
      @close="showPreviousRequestsModal = false"
      @repeat-request="handleRepeatRequest"
    />
    <RecentRequestsModal
      :requests="requests"
      :isOpen="showRecentRequestsModal"
      @close="showRecentRequestsModal = false"
      @repeat-request="handleRepeatRequest"
    />
  </div>
  
</template>

<script>

import UserBadge from '../components/UserBadge.vue'
import { DeviceUUID } from 'device-uuid';
import axios from 'axios';
import LoadingOverlay from '../components/LoadingOverlay1.vue'
import ContextMenu from '../components/ContextMenu.vue'
import StatisticsModal from '../components/StatisticsModal.vue'
import PreviousRequestsModal from '../components/PreviousRequestsModal.vue'
import RecentRequestsModal from '../components/RecentRequestsModal.vue'
import SearchItem from '../components/SearchItem.vue'
import InsertItem from '../components/InsertItem.vue'
import OrderList from '../components/OrderList.vue'
import LookUp from '../components/LookUp.vue'
import { shallowRef } from 'vue'
export default {
  name: 'TransferRequestsPage',
  components: { UserBadge,LoadingOverlay,ContextMenu,StatisticsModal,PreviousRequestsModal,RecentRequestsModal,SearchItem,InsertItem,OrderList,LookUp},
  data() {
    return {
      // large items dataset (for demo assume 10k items)
      dropdownDiscounts: {},
      items: [],
      showNotes:false,
      itemsSearch:[],
      warehouses:[],
      accounts:[],
      seqAcc:0,
      warehouse_matrial:1,
      uid:new DeviceUUID().get(),
      searchQuery: '',
      kind:'',
      kinds:['مشتريات','مبيعات','ادخال','اخراج','نقل'],
      kinds2:[{Seq:1,Name:"مشتريات"},{Seq:2,Name:"مبيعات"},{Seq:3,Name:"ادخال"},{Seq:4,Name:"اخراج"},{Seq:5,Name:"نقل"}],
      searchResults: [],
      searchLoading: false,
      debounceTimer: null,
      selectedItem: null,
      selectedItems: [],
      transferQty: 1,
      transferTo: 'فرع الجنوب',
      transferFrom:'',
      account:'',
      transferUnit: 'وحدة',
      nextRequestNumber: 1,
      showStatistics:false,
      showRecentRequestsModal:false,
      showPreviousRequestsModal:false,   
      requests_previos:[],         
      loading:false,
      transferNotes:'',
      showSearchDropdown: false,
      browseDropdownTimer: null,    
      dropdownQuantities: {},
      dropdownUnits: {},  
      requests: [           
      ]
    }
  },
  computed: {
    itemsCount() {
      return this.items.length.toLocaleString('en-EG')
    },
    dropdownItems() {
      const q = this.searchQuery && this.searchQuery.trim()
      if (q) return this.searchResults
      return this.itemsSearch.slice(0, 50)
    }
  },
  async created() {    
    //await this.load_data();
  },
  beforeRouteEnter(to, from, next) {
    if (from.name) {
      // هذا يعني أن المستخدم جا من صفحة ثانية (مو refresh)      
      console.log("تم الانتقال من صفحة ثانية");
      next(async (vm) => {
        await vm.load_data(); // ✅ هنا تقدر تنفذ الدالة
      });      
    }
    else
      next();    
  },
  methods: {    
    
    async load_data(){
      const nums = this.requests.map(r => r.requestNumber || 0)
      const max = nums.length ? Math.max(...nums) : 0
      this.nextRequestNumber = max + 1   
      this.loadingMessage = "جاري تحميل البيانات";
      this.loading = true;         
      await this.Get_DataInfo();
      /*await this.Get_Warehouse()
      this.loadingMessage = "جاري تحميل المستودعات";
      this.loading = true;
      await this.Get_Warehouse()
      this.loading=false;
      this.loadingMessage = "جاري تحميل مستودعات النقل";
      this.loading=true;
      await this.Get_Warehouse_Transfer();
      this.loading=false;
      this.loadingMessage = "جاري تحميل المواد";  
      this.loading=true;
      await this.Get_Material()             
      this.loading=false;
      this.loadingMessage = "جاري تحميل حسابات المستخدم";
      this.loading=true;    
      await this.Get_Accounts()*/
      //this.loadingMessage = "جاري تحميل البيانات";
      //this.loading = true;
      //await this.Get_DataInfo()
      this.itemsSearch = this.generateItems(3)            
      this.read_parm_localstorage("OrderTransfer");
      this.read_parm_localstorage("requestTransfer");
      this.write_parm_to_localstorage("CurrentPage","Transfer");    
      setTimeout(() => {
          this.loading = false
        }, 800);
    },
    handleRepeatRequest(request) {
      const itemsToRepeat = request.items || []
      if (itemsToRepeat.length === 0) {
        alert('لا يمكن تكرار هذا الطلب')
        return
      }
      
      // إضافة المواد من الطلب السابق إلى القائمة المختارة
      itemsToRepeat.forEach(item => {
        const existingItem = this.selectedItems.find(s => s.item.code === item.code)
        if (!existingItem) {
          // البحث عن المادة في قائمة الكل
          const fullItem = this.items.find(i => i.code === item.code)
          if (fullItem) {
            this.selectedItems.push({
              item: fullItem,
              qty: item.qty,
              unit: item.unit,
              discount: item.discount || 0,
              discountAmount: item.discountAmount || 0,
              manualPrice: item.manualPrice || fullItem.price
            })
          }
        }
      })
      
      this.transferTo = request.to
      alert(`تم تكرار الطلب السابق - ${itemsToRepeat.length} مادة مختارة`)
    },
    async handleMenuSelect(option) {
      switch(option) {
        case 'search':
          this.$nextTick(() => {
            const el = this.$refs.searchInput
            if (el && typeof el.focus === 'function') el.focus()
          })
          break
        case 'previous-requests':
          this.loading=false;
          this.loadingMessage = "جاري تحميل الطلبات";  
          this.loading=true;
          this.requests_previos = await this.Get_Orders(false)          
          this.requests_previos = this.requests_previos.sort((a,b)=>b.requestNumber-a.requestNumber)  
          this.requests_previos = this.requests_previos.sort((a,b)=>b.kind-a.kind)
          this.loading=false;
          this.showPreviousRequestsModal = true
          break
        case 'recent':    
          this.loading=false;
          this.loadingMessage = "جاري تحميل الطلبات اليوم";  
          this.loading=true;
          this.requests = await this.Get_Orders(true)
          this.write_parm_to_localstorage("requestTransfer",JSON.stringify(this.requests))            
          this.loading=false;       
          this.showRecentRequestsModal = true
          break
        case 'statistics': {
          this.showStatistics = true
          break
        }
        case 'refresh':
          this.loading = true
          this.loadingMessage = 'جارٍ تحديث البيانات...'
          await this.load_data()
          setTimeout(() => {
            this.loading = false
            this.loadingMessage = ''
            alert('تم تحديث البيانات بنجاح')
          }, 1500)
          break
        case 'settings':
          alert('سيتم فتح صفحة الإعدادات')
          break
        case 'help':
          alert('مرحباً بك في المساعدة!\n\nهنا يمكنك:\n1. البحث عن المواد\n2. إنشاء طلب نقل جديد\n3. تتبع الطلبات السابقة\n4. تكرار الطلبات')
          break
      }
    },
    UpdateItemsTransferLocalStorage(){
      this.write_parm_to_localstorage("OrderTransfer",JSON.stringify(this.selectedItems))
    },
    write_parm_to_localstorage(key,value){
        localStorage.setItem(key,value);
    },
    read_parm_localstorage(key){
      try{
          if(key == "OrderTransfer")
            this.selectedItems = JSON.parse(localStorage.getItem("OrderTransfer")==null ? [] : localStorage.getItem("OrderTransfer"));
          else if(key == "requestTransfer"){
            this.requests =JSON.parse(localStorage.getItem("requestTransfer")==null ? [] : localStorage.getItem("requestTransfer"));
          }
          else if(key == "itemTransfer"){
            let countItem = JSON.parse(localStorage.getItem("OrderTransfer")==null ? [] : localStorage.getItem("OrderTransfer")).length;   
            for(let i=0 ; i<countItem;i++){
              if(localStorage.getItem("itemTransfer"+i) != null)
                this.selectedItems.push(JSON.parse(localStorage.getItem("itemTransfer"+i)))              
            }
          }
      }catch{
          console.log()
      }        
    },
    remove_parm_localstorage(key){
      localStorage.removeItem(key);
    },
    async show_alert(text, Icon) {
      await this.$swal.fire({
        //  title: "Are you sure?",
        text: text,
        icon: Icon,
        //iconHtml: "!",
        //showCancelButton: true,
        showConfirmButton: false,
        confirmButtonColor: "#d33",
        //cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        timer: 5000
      });
    },
    async post_request(url, ip) {
      try {
        let result = '';
       // const fp1 = await FingerprintJS.load()
       // const result1 = await fp1.get()

        //const visitorId1 = result1.visitorId
        if((localStorage.getItem('username2') == null || localStorage.getItem('username2') == '') && (localStorage.getItem('password2') == null || localStorage.getItem('password2') == '')){        
          return;        
        }        
        if(localStorage.getItem('BCloud') == 'true'){
            url += "%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26SESSION%3D' +localStorage.getItem("session") ;
            url = {Username:localStorage.getItem("username2"), Password:localStorage.getItem("password2"),url:url,SESSION:localStorage.getItem("session")};
            ip = localStorage.getItem('ip');
        }else{
          url += "%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26SESSION%3D' +localStorage.getItem("session") + '%26Ip%3D' +localStorage.getItem("session")   ;
          ip = localStorage.getItem('ip2');
        }
        let response = () => {          
          return new Promise(function (resolve) {
            axios.post( ip , url,
              {
                'Content-type': 'plain/text'
              }).then(response => {
                resolve(response);
              }).catch(async () => {
                resolve('Error')
              });
          });
        };
        result = await response();
        return result;
      } catch {
        return 'Error';
      }
    },
    async Insert_order(items){
      var type_order = "Entry";
        const date = new Date();
        const milliseconds = date.getMilliseconds();
        const houer = date.getHours();
        const minutes = date.getMinutes();
        const second = date.getSeconds();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        let token = ''
        const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
        for (let i = 0; i < 4; i++) {
          token += str[parseInt(Math.random() * str.length)];
        }
        token += '-' + year + month + day + '+' + houer + minutes + second + '+' + milliseconds
        const token_order = token;
        token = localStorage.getItem('token') ;
        const date_add = year + '-' + month + '-' + day + '+' + houer + ':' + minutes + ':' + second;
        const method = 'WEB_InsertInvoice_transfer',  customer_name = '', remarks = '', total = 0, currency = 0,
        items_count = this.selectedItems.length, tag_printer = '', flag = true, localseq = 0, total_discount = 0, to_warehouse = this.transferTo, is_order = true,
        IsInventory = true, //kind = this.kind+1,
        longitude = 0, latitude = 0;
        let acc = 0;
        if(this.kind != 4 && this.account != -1){
          //acc = this.accounts[this.account].Seq;
          acc = this.account
        }
        let urlPost = 'method=' + method + '&&account=' + acc + '&customer_name=' + customer_name + '&username=' + localStorage.getItem("username") + '&password=' + localStorage.getItem("password");
        urlPost += '&remarks=' + remarks + '&total=' + total + '&currency=' + currency + '&items_count=' + items_count + '&items_json=' + JSON.stringify(items);
        urlPost += '&tag_printer=' + tag_printer + '&token=' + token + '&date_add=' + date_add + '&flag=' + flag;
        urlPost += '&localseq=' + localseq + '&total_discount=' + total_discount + '&to_warehouse=' + to_warehouse + '&is_order=' + is_order + '&IsInventory=' + IsInventory + '&kind=' + this.kind;
        urlPost += '&longitude=' + longitude + '&latitude=' + latitude + '&db_guid=' + localStorage.getItem('db_guid') + '&android_id=' + this.uid;
        urlPost += '&typeOrder=' + type_order + '&token_order='+token_order;
        const encoded = encodeURIComponent(urlPost);

        let responseData = await this.post_request(encoded, localStorage.getItem("ip"));
        if (responseData == 'Error') {          
          //this.loadingMessage = 'فشل في الاتصال بالمخدم'
          this.load_message('فشل في الاتصال بالمخدم')
          //await this.show_alert('فشل في الاتصال بالمخدم', "error");
          return false;
        }
        if (responseData.data[0]['State'] == false) {
          //await this.show_alert(responseData.data[0]['Response'], "error");          
          this.loadingMessage = responseData.data[0]['Response']
          this.load_message(responseData.data[0]['Response'])
          return false;
        } else {
          this.load_message(responseData.data[0]['Response'])
          //this.loadingMessage = responseData.data[0]['Response']
          //await this.show_alert(responseData.data[0]['Response'], "success");
          return responseData.data[0]['EdNum'];
        }
    },
    async Get_Warehouse() {
      var str = 'method%3DWEB_GetVersion%26username%3D' + localStorage.getItem('username') + '%26password%3D' + localStorage.getItem('password') + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
      let responseData = await this.post_request(str, localStorage.getItem("ip"));
      console.log(responseData);
      if (responseData == 'Error') {
        //this.loading = false;
        //await this.show_alert('فشل في الاتصال بالمخدم', "error");
        this.loadingMessage='فشل في الاتصال بالمخدم';
        return;
      }
      if ((parseInt(responseData.data[0]['Major']) == 1 && parseInt(responseData.data[0]['Minor']) >= 0)) {
        str = 'method%3DWEB_GetWarehouse%26%26username%3D' + localStorage.getItem('username') + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26android_id%3D' + this.uid;
        responseData = await this.post_request(str, localStorage.getItem("ip"));
        
        if (responseData == 'Error') {
          //this.loading = false;
          //await this.show_alert('فشل في الاتصال بالمخدم', "error");
          this.loadingMessage='فشل في الاتصال بالمخدم';
          return;
        }
        //this.InventoryMetrial = responseData.data[0]['dataTable']
        this.warehouses = responseData.data[0]['dataTable']
      } else {
        localStorage.clear();
        //await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");
        this.loadingMessage=responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'];
        //this.$router.push({ name: 'login' })
      }
    },
    async Get_Orders(isToday) {
      var str = 'method%3DWEB_GetOrders%26username%3D' + localStorage.getItem("username") + '%26password%3D' + localStorage.getItem("password")+'%26IsToday%3D'+isToday;
      let responseData = await this.post_request(str, localStorage.getItem("ip"));
      if (responseData == 'Error') {
        //this.loading = false;
        //await this.show_alert('فشل في الاتصال بالمخدم', "error");
        this.loadingMessage='فشل في الاتصال بالمخدم';
        return null;
      }
//      this.requests = responseData.data[0]['dataTable']
      console.log(this.requests);
      console.log(responseData.data[0]['dataTable']);
      return responseData.data[0]['dataTable']
    },
    async Get_Material() {        
        var str = 'method%3DWEB_GetVersion%26username%3D' + localStorage.getItem('username') + '%26password%3D' + localStorage.getItem('password') + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
        let responseData = await this.post_request(str, localStorage.getItem("ip"));
        if (responseData == 'Error') {
            //this.loading = false;
            //await this.show_alert('فشل في الاتصال بالمخدم', "error");
            this.loadingMessage='فشل في الاتصال بالمخدم';
            return;
        }
        if ((parseInt(responseData.data[0]['Major']) == 1 && parseInt(responseData.data[0]['Minor']) >= 0)) {        
            str = 'method%3DWEB_GetArtical%26%26username%3D' + localStorage.getItem('username') + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26Group_Mat%3D(-1)%26%26android_id%3D' + this.uid + '%26Warehouse%3D' + this.warehouse_matrial;
            responseData = await this.post_request(str, localStorage.getItem("ip"))
            if (responseData == 'Error') {
            //this.loading = false;
            //await this.show_alert('فشل في الاتصال بالمخدم', "error");
            this.loadingMessage='فشل في الاتصال بالمخدم';
            return;
            }
            this.items = responseData.data[0]['dataTable']
        } else {
            localStorage.clear();
            //await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");
            this.loadingMessage=responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'];            
            //this.$router.push({ name: 'login' })
        }        

    },
    async Get_Warehouse_Transfer() {
      var str = 'method%3DWEB_GetVersion%26username%3D' + localStorage.getItem('username') + '%26password%3D' + localStorage.getItem('password') + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
      let responseData = await this.post_request(str, localStorage.getItem("ip"));
      try{      
        if (responseData == 'Error') {
          //this.loading = false;
          //await this.show_alert('فشل في الاتصال بالمخدم', "error");          
          await this.load_message('فشل في الاتصال بالمخدم');
          return;
        }
        if ((parseInt(responseData.data[0]['Major']) == 1 && parseInt(responseData.data[0]['Minor']) >= 0)) {
          str = 'method%3DWEB_GetWarehouse_Transfer%26%26username%3D' + localStorage.getItem('username') + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26android_id%3D' + this.uid;
          responseData = await this.post_request(str, localStorage.getItem("ip"));
          if (responseData == 'Error') {
          // this.loading = false;
            //await this.show_alert('فشل في الاتصال بالمخدم', "error");            
            await this.load_message('فشل في الاتصال بالمخدم');
            return;
          }else if(responseData.data[0]['State'] == false){
            await this.load_message((responseData.data[0]['Response']))   
            return;
          }
          //this.InventoryMetrial = responseData.data[0]['dataTable']
          /*for(let i =0 ;i<this.warehouses.length;i++){
            if(this.warehouses[i]["Seq"] == responseData.data[0]['dataTable'][0]['loadwarehouse'])
              this.transferTo = i;
            if(this.warehouses[i]["Seq"] == responseData.data[0]['dataTable'][0]['warehouse'])
              this.transferFrom = i; 
          }*/
          this.transferTo = responseData.data[0]['dataTable'][0]['loadwarehouse'];
          this.transferFrom = responseData.data[0]['dataTable'][0]['warehouse'];
        } else {
          localStorage.clear();
          //await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");          
          await this.load_message((responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response']));
          //this.$router.push({ name: 'login' })
        }
      } catch(error){
          await this.load_message(error);
          return;
      }
      
    },
    async Get_Accounts() {
      var str = 'method%3DWEB_GetVersion%26username%3D' + localStorage.getItem('username') + '%26password%3D' + localStorage.getItem('password') + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid');
      let responseData = await this.post_request(str, localStorage.getItem("ip"));
      if (responseData == 'Error') {
        //this.loading = false;
        //await this.show_alert('فشل في الاتصال بالمخدم', "error");
        this.loadingMessage='فشل في الاتصال بالمخدم';
        return;
      }
      if ((parseInt(responseData.data[0]['Major']) == 1 && parseInt(responseData.data[0]['Minor']) >= 0)) {
        str = 'method%3DWEB_GetAccounts%26%26username%3D' + localStorage.getItem('username') + '%26%26password%3D' + localStorage.getItem('password') + '%26%26db_guid%3D' + localStorage.getItem('db_guid') + '%26%26android_id%3D' + this.uid;
        responseData = await this.post_request(str, localStorage.getItem("ip"));
        if (responseData == 'Error') {
          //this.loading = false;
          //await this.show_alert('فشل في الاتصال بالمخدم', "error");
          this.loadingMessage='فشل في الاتصال بالمخدم';
          return;
        }
        //this.InventoryMetrial = responseData.data[0]['dataTable']
        this.accounts = responseData.data[0]['dataTable']
      } else {
        localStorage.clear();
        //await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");
        this.loadingMessage=responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'];
        //this.$router.push({ name: 'login' })
      }
    },
    async Get_DataInfo() {
      var str = 'method%3DWEB_GetData'+'%26db_guid%3D' + localStorage.getItem('db_guid')+'%26username%3D' + localStorage.getItem('username') + '%26password%3D' + localStorage.getItem('password') +'%26token%3D' + localStorage.getItem('token') + '%26Warehouse%3D' + this.warehouse_matrial + '%26Group_Mat%3D(-1)';
      let responseData = await this.post_request(str, localStorage.getItem("ip"));      
      if (responseData == 'Error') {
        this.loadingMessage='فشل في الاتصال بالمخدم';
        return;
      }
      let dt_Info = '';
      if(responseData.data['VersionInfo'] == null){
        this.loadingMessage='فشل بجلب إصدار المخدم';         
        return;
      }
      dt_Info = JSON.parse(responseData.data['VersionInfo'])[0]
      if ((parseInt(dt_Info['Major']) == 1 && parseInt(dt_Info['Minor']) >= 0)) {
        if(responseData.data['WarehouseInfo'] == null){
          this.loadingMessage='فشل بجلب المستودعات';         
          return;
        }        
        if(responseData.data['WarehouseTransferInfo'] == null){
          this.loadingMessage='فشل بجلب مستودع النقل';         
          return;
        }
        if(responseData.data['ArticleInfo'] == null){
           this.loadingMessage='فشل بجلب المواد';         
           return;
        }
        if(responseData.data['AccountsInfo'] == null){
           this.loadingMessage='فشل بجلب الحسابات';         
           return;
        }
        console.log("*******************************************************")
        console.log(JSON.parse(responseData.data['AccountsInfo'])[0]['dataTable'])
        
        this.kinds2 = JSON.parse(responseData.data['PrivilageInfo'])[0]['dataTable'];
        this.warehouses = JSON.parse(responseData.data['WarehouseInfo'])[0]['dataTable'];
        console.log(this.warehouses)
        this.items = JSON.parse(responseData.data['ArticleInfo'])[0]['dataTable'];        
        console.log(this.items)
        this.accounts = JSON.parse(responseData.data['AccountsInfo'])[0]['dataTable']
        console.log(this.accounts)
        this.transferTo = JSON.parse(responseData.data['WarehouseTransferInfo'])[0]['dataTable'][0]['loadwarehouse'];
        this.transferFrom = JSON.parse(responseData.data['WarehouseTransferInfo'])[0]['dataTable'][0]['warehouse'];
        console.log(this.transferTo)
        console.log(this.transferFrom)
      } else {
        localStorage.clear();
        //await this.show_alert(responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'], "error");
        this.loadingMessage=responseData.data[0]['Response'] == null ? 'يرجى تحديث المخدم' : responseData.data[0]['Response'];
        //this.$router.push({ name: 'login' })
      }
    },
    async load_message(message){
      this.loading = false;     
      this.loading = true;     
      this.loadingMessage = message;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.loading = false;     
    },
    generateItems(prAccount) {
      //this.load_message('**************')
      const arr = []      
      let st_pr = '';
     for (let i = 0; i < this.items.length; i++) {
      console.log(prAccount)
      this.items[i].sellpr = `${shallowRef({Seq:prAccount,Name:st_pr})}`;                 
      if(prAccount == 5){
        st_pr='سعر خاص'
        this.items[i].price = this.items[i].sellpr5;   
      }        
      else if(prAccount == 4){
        st_pr='سعر المستهلك'
        this.items[i].price = this.items[i].sellpr4;   
      }        
      else if(prAccount == 3){
        st_pr='سعر المفرق'
        this.items[i].price = this.items[i].sellpr3;
      }        
      else if(prAccount == 2){
        st_pr='سعر نصف الجملة'
        this.items[i].price = this.items[i].sellpr2;
      }        
      else{
        st_pr='سعر الجملة'
        this.items[i].price = this.items[i].sellpr1;
      }                 
      arr.push({
        id: `${this.items[i].seq}`,
        name: `${this.items[i].name1}`,
        code: `${this.items[i].num}`,
        barcode:`${this.items[i].barcode}`,
        stock: `${this.items[i].qty}`,
        Defunit:`${this.items[i].Defunit}`,
        unt1:`${this.items[i].unt1}`,
        unt2:`${this.items[i].unt2}`,
        unt3:`${this.items[i].unt3}`,
        unit:[`${this.items[i].unt1}`,`${this.items[i].unt2}`,`${this.items[i].unt3}`],
        qty:1,
        UFactor2:`${this.items[i].UFactor2}`,
        UFactor3:`${this.items[i].UFactor3}`,
        sellpr1: `${this.items[i].sellpr1}`,
        sellpr2: `${this.items[i].sellpr2}`,         
        sellpr3: `${this.items[i].sellpr3}`,
        sellpr4: `${this.items[i].sellpr4}`,
        sellpr5: `${this.items[i].sellpr5}`,
        sellpr:shallowRef({Seq:prAccount,Name:st_pr}),
        price:`${this.items[i].price}`
        //sellpr:[`${this.items[i].sellpr1}`,`${this.items[i].sellpr2}`,`${this.items[i].sellpr3}`,`${this.items[i].sellpr4}`,`${this.items[i].sellpr5}`]
      })
      }   
      return arr
    },
    updatePrice(prAccount){
      for (let i = 0; i < this.selectedItems.length; i++) {                
        if(prAccount == 5){
          this.selectedItems[i].price = this.selectedItems[i].sellpr5;   
        }        
        else if(prAccount == 4){
          this.selectedItems[i].price = this.selectedItems[i].sellpr4;  
        }        
        else if(prAccount == 3){
          this.selectedItems[i].price = this.selectedItems[i].sellpr3;  
        }        
        else if(prAccount == 2){
          this.selectedItems[i].price = this.selectedItems[i].sellpr2;  
        }        
        else{
          this.selectedItems[i].price = this.selectedItems[i].sellpr1;  
        }   
      }
    },
    
    clearSelected() {
      this.selectedItems = []
      this.$nextTick(() => {
        const el = this.$refs.searchInput
        if (el && typeof el.focus === 'function') el.focus()
      })
    },
    async sendTransferRequest() {
      console.log("this.kind:"+this.kind);
      console.log("this.account:"+this.account);
      console.log("this.transferFrom:"+this.transferFrom);
      console.log("this.transferTo:"+this.transferTo);
      if(this.kind<=0){            
        return;
      }else if(this.kind == 5){
        if(this.transferFrom <= 0 || this.transferTo <= 0)
          return ;
      }else if( this.kind != 5){
        if(this.account <= 0 || this.transferFrom <= 0){
          return;
        }
      }
      const payloadItems = this.selectedItems.map(s => ({
        seq:s.item.id,
        name: s.item.name,
        code: s.item.code,
        stock: Number(s.item.stock) || 1,
        unit: s.item.unit[s.item.Defunit],
        unit_num: s.item.Defunit,
        qty:s.item.qty,
        discount: s.discount || 0,
        discountAmount: s.discountAmount || 0,
        manualPrice: s.manualPrice || s.item.price
      }));
      const ListItem = this.selectedItems.map(s => ({
        Seq:s.item.id,
        Price: s.item.price,
        Unit: s.item.Defunit,
        Warehouse: this.kind != 5 ? this.transferFrom : this.transferTo,//this.transferTo : this.transferFrom,
        Quantity: s.item.Defunit == 0 ? s.item.qty : (s.item.Defunit == 1 ?  (parseFloat(s.item.qty) * parseFloat(s.item.UFactor2)) : (parseFloat(s.item.qty) * parseFloat(s.item.UFactor3))) ,
        Subtotal: parseFloat(s.item.qty)*parseFloat(s.item.price),
        Remarks:'',
        discountPercent:s.item.discount,
        discount:s.item.discountAmount
      }));      
      console.log(ListItem)
      this.loading = true
      this.loadingMessage = 'جارٍ إرسال الطلب...'      
      var res = await this.Insert_order(ListItem);      
      if(res != false){
        this.loading = false
        this.loading = true
        this.loadingMessage = `تم إضافة الطلب ${res}`
        const d = new Date();
        const formatted = /*d.getFullYear() + "-" +
        String(d.getMonth() + 1).padStart(2, "0") + "-" +
        String(d.getDate()).padStart(2, "0") + " " +*/
        String(d.getHours()).padStart(2, "0") + ":" +
        String(d.getMinutes()).padStart(2, "0") /*+ ":" +
        String(d.getSeconds()).padStart(2, "0")*/;
        console.log(this.warehouses);
        console.log(this.transferFrom);
        console.log(this.transferTo);
        const newRequest = {
        //id: Date.now(),
        requestNumber: `${res}`,
        title: `طلب ${this.kinds2[this.kind-1].Name} -  ${res}`,
        date: new Date().toISOString().slice(0, 10),
        time:formatted,
        status: 'notClosed',//not closed
        statusText: 'الطلب غير مرحل', //الطلب غير مرحل
        from: this.warehouses[this.warehouses.findIndex(u => u.Seq === this.transferFrom)].Name,
        to: this.warehouses[this.warehouses.findIndex(u => u.Seq === this.transferTo)].Name,
        items: payloadItems,
        kind:this.kind,
        nameSender:'abd',
        userId:0
        }
        console.log('requests2:*************************');
        this.requests.unshift(newRequest)
        console.log('requests2:'+this.requests);
        this.write_parm_to_localstorage("requestTransfer",JSON.stringify(this.requests))
        this.remove_parm_localstorage('OrderTransfer');
        this.selectedItems = []
        this.selectedItem = null
        this.transferQty = 1
        //this.transferTo = 'فرع الجنوب'
        this.transferUnit = 'وحدة'
        this.searchQuery = ''                    
    }else{          
      //this.loadingMessage = ''
    }
      /*setTimeout(() => {
        this.loading = false
      }, 2000);*/
      /*setTimeout(() => {
        this.requests.unshift(newRequest)
        this.write_parm_to_localstorage("requestTransfer",JSON.stringify(this.requests))
        this.selectedItems = []
        this.selectedItem = null
        this.transferQty = 1
        //this.transferTo = 'فرع الجنوب'
        this.transferUnit = 'وحدة'
        this.searchQuery = ''
        this.loading = false
        this.loadingMessage = ''
        //this.$nextTick(() => alert('تم إرسال طلب التحويل'))
      }, 800)*/
    },
    goBack() {
      this.$router.push({name:"Dashboard"})
    }
  }
}
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  padding: 30px 20px;
  /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
  background: linear-gradient(135deg, #ffffff 0%, #ffffff 100%);
  direction: rtl;
}

.page-header {
  max-width: 1000px;
  margin: 0 auto 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-actions { display:flex; align-items:center; gap:12px }
.right-actions { display:flex; align-items:center; gap:12px }

.btn-back {
  background: white;
  color: #667eea;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.btn-back:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.page-title {
  color: white;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
}

.content {
  max-width: 1000px;
  margin: 0 auto;
}

.btn-toggle-notes { background: transparent; border: none; font-size: 18px; cursor: pointer; padding: 4px 8px; border-radius: 6px; transition: all 0.2s ease; opacity: 0.7 }
.btn-toggle-notes:hover { opacity: 1; background: #f1f5f9; transform: scale(1.1) }
.notes-field { margin-bottom: 18px }
.notes-input { height: 50px; width: min(100%, 100%); box-sizing: border-box; min-height: 30px; padding: 12px; border-radius: 12px; border: 1px solid #f1e7ff; box-shadow: 0 8px 20px rgba(118,75,162,0.06); resize: vertical; font-size: 14px; color: #222 }
.notes-input::placeholder { color: #9CA3AF }
.notes-input:focus { outline: none; border-color: #667EEA; box-shadow: 0 0 0 3px rgba(102,126,234,0.1), 0 4px 12px rgba(102,126,234,0.1); }

</style>
-->